import { useState, useEffect } from "react";
import { Link } from "react-router";
import { ChevronLeftIcon, EyeCloseIcon, EyeIcon } from "../../icons";
import Label from "../Usados/Label";
import Input from "../Usados/InputField";
import Button from "../ui/button/Button";
import { useNavigate } from "react-router";
import { useAuth } from "@/context/AuthContext";
import { getSessionItem, setSessionItem } from "@/utils/storage";

export default function SignInForm() {
  const navigate = useNavigate();
  const { user, token, setUser, setToken, isMobileApp } = useAuth();
  const [showPassword, setShowPassword] = useState(false);
  const [userInput, setUserInput] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState<string | null>(null);

  useEffect(() => {
    if (isMobileApp && user && token) {
      navigate("/home");
    }
  }, [isMobileApp, user, token, navigate]);

  const backend_api = import.meta.env.VITE_API_URL_BACKEND;

  async function logIn() {
    setMessage("Enviando solicitud...");

    try {
      const response = await fetch(`${backend_api}/usuarios/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          identificador: userInput,
          contrasena: password,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        setMessage(JSON.stringify(data, null, 2));
        return;
      }
      setSessionItem("token", data.token);
      setSessionItem("user", JSON.stringify(data.usuario));
      setSessionItem("tenantId", data.usuario.tenantId);
      setSessionItem("tenant_codigo", data.usuario.tenantId);
      setSessionItem("empresa", data.usuario.empresa);
      setSessionItem("db_name", data.usuario.db_name);
      setSessionItem("last_user_input", userInput);

      setToken(data.token);
      setUser(data.usuario);

      setMessage("Login OK - Redirigiendo...");
      navigate("/home");
    } catch (error: any) {
      console.error("Login error:", error);
      const cachedToken = getSessionItem("token");
      const cachedUser = getSessionItem("user");
      const lastInput = getSessionItem("last_user_input");

      if (cachedToken && cachedUser && lastInput === userInput) {
        setToken(cachedToken);
        setUser(JSON.parse(cachedUser));
        navigate("/home");
        return;
      }
      setMessage("Error en login: " + error.message);
    }
  }

  return (
    <div className="flex flex-col flex-1">
      <div className="w-full max-w-md pt-10 mx-auto">
        <Link
          to="/"
          className="inline-flex items-center text-sm text-gray-500 transition-colors hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300"
        >
          <ChevronLeftIcon className="size-5" />
          Regresar al inicio
        </Link>
      </div>
      <div className="flex flex-col justify-center flex-1 w-full max-w-md mx-auto">
        <div>
          <div className="mb-5 sm:mb-8">
            <h1 className="mb-2 font-semibold text-gray-800 text-title-sm dark:text-white/90 sm:text-title-md">
              Iniciar sesion
            </h1>
            <p className="text-sm text-gray-500 dark:text-gray-400">
              Usando correo electronico o numero de documento con la contraseña
              correspondiente
            </p>
          </div>

          <div className="space-y-6">
            <div>
              <Label>
                Numero de documento / correo electronico{" "}
                <span className="text-error-500">*</span>
              </Label>
              <Input
                id="user"
                placeholder="Correo / Numero de documento"
                value={userInput}
                onChange={(e: any) => setUserInput(e.target.value)}
              />
            </div>

            <div>
              <Label>
                Contraseña <span className="text-error-500">*</span>
              </Label>
              <div className="relative">
                <Input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  placeholder="Contraseña"
                  value={password}
                  onChange={(e: any) => setPassword(e.target.value)}
                />
                <span
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute z-30 -translate-y-1/2 cursor-pointer right-4 top-1/2"
                >
                  {showPassword ? (
                    <EyeIcon className="fill-gray-500 dark:fill-gray-400 size-5" />
                  ) : (
                    <EyeCloseIcon className="fill-gray-500 dark:fill-gray-400 size-5" />
                  )}
                </span>
              </div>
            </div>

            <div className="flex items-center justify-between">
              <div />
              <Link
                to="#"
                className="text-sm text-brand-500 hover:text-brand-600 dark:text-brand-400"
              >
                ¿Olvidaste tu contraseña?
              </Link>
            </div>

            <div>
              <Button onClick={() => logIn()} className="w-full" size="sm">
                Iniciar sesion
              </Button>
            </div>

            {/* Aqui mostramos los mensajes del backend */}
            {message && (
              <pre className="mt-4 p-2 text-sm bg-gray-100 dark:bg-gray-800 rounded text-red-500">
                {message}
              </pre>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
